(ns net.kestec.mhda-pilgrimage.lib-ui.are-you-sure-popup
  (:require ["@mui/material/Button" :default Button]
            ["@mui/material/Typography" :default Typography]
            ["@mui/material/Modal" :default Modal]
            ["@mui/material/Grid" :default Grid]
            ["@mui/material/TextField" :default TextField]
            ["@mui/icons-material/Cancel" :default CancelIcon]
            ["@mui/icons-material/Done" :default DoneIcon]
            [net.kestec.mhda-pilgrimage.db :as-alias db]
            [ajax.core :as ajax]
            [net.kestec.re-frame.event :as-alias event]
            ["react" :as react]
            [re-frame.core :as rf]
            [reagent.core :as r]))


(rf/reg-event-db
  ::set-show-are-you-sure-popup
  (fn [db [_ url]]
    (assoc db ::show-are-you-sure-popup url)))

(defn- are-you-sure-popup-form* [msg on-success on-close]
  (let []
    [:div
     {:class "modal"
      :style {:max-height "70vh" :max-width "70vw" :min-height "400px" :min-width "400px"}}
     [:div
      ;[:pre "PRE "(pr-str claim)]
      [:> Grid {:container  true
                :direction  "row"
                :justify    "center"
                :alignItems "flex-start"
                :spacing    2}


       [:> Grid {:item true :xs 12}

        [:br]
        [:> Typography (or msg "Sind sie sicher?")]
        ]

       [:> Grid {:item true :xs 12}]]]
     [:br]
     [:br]

     [:> Button
      {:style     {:float "left"}
       :variant   "outlined"
       :startIcon (r/as-element [:> CancelIcon])
       :onClick   #(do (rf/dispatch [::set-show-are-you-sure-popup nil]) (when on-close (on-close)))
       }
      "Abbrechen"]
     [:> Button
      {:style     {:float "right"}
       :variant   "outlined"
       :startIcon (r/as-element [:> DoneIcon])
       :onClick   #(do (on-success) (rf/dispatch [::set-show-are-you-sure-popup nil]))
       }
      "Ja"]
     ]
    ))

(defn- are-you-sure-word-popup-form* [!control msg on-success on-close]

  [:div
   {:class "modal"
    :style {:max-height "70vh" :max-width "70vw" :min-height "400px" :min-width "400px"}}
   [:div
    ;[:pre "PRE "(pr-str claim)]
    [:> Grid {:container  true
              :direction  "row"
              :justify    "center"
              :alignItems "flex-start"
              :spacing    2}

     ;[:> Grid {:item true :xs 12} (pr-str claim)]
     [:> Grid {:item true :xs 12}

      [:br]
      [:> Typography (or msg "Sind sie sicher?")]
      [:> Typography "Bitte geben sie `Malteser` ein um fortzufahren"]
      ]

     [:> Grid {:item true :xs 12}
      [:> TextField {:label           "Kontrollwort Malteser"
                     :fullWidth       true
                     :size            "small"
                     :value           @!control
                     :onChange        #(reset! !control (.. % -target -value))
                     :InputLabelProps {:disableAnimation true :shrink true}}
       ]
      ]
     ]
    [:br]
    [:br]
    [:> Grid {:item true :xs 12}

     [:> Button
      {:style     {:float "left"}
       :variant   "outlined"
       :startIcon (r/as-element [:> CancelIcon])
       :onClick   #(do (rf/dispatch [::set-show-are-you-sure-popup nil]) (when on-close (on-close)))
       }
      "Abbrechen"]
     [:> Button
      {:style     {:float "right"}
       :disabled  (not= @!control "Malteser")
       :variant   "outlined"
       :startIcon (r/as-element [:> DoneIcon])
       :onClick   #(do (on-success) (rf/dispatch [::set-show-are-you-sure-popup nil]))
       }
      "Ja"]
     ]]]
  )

(defn are-you-sure-popup [msg-fn on-success & [on-close]]
  (when-let [show-popup @(rf/subscribe [::db/get ::show-are-you-sure-popup])]
    [:> Modal {:aria-labelledby  "simple-modal-title"
               :aria-describedby "simple-modal-description"
               :style            {:display        "flex"
                                  :marginRight    "auto"
                                  :marginLeft     "auto"
                                  :alignItems     "center"
                                  :justifyContent "center"}
               :open             (if (nil? show-popup) false true)

               }
     (let [msg (msg-fn show-popup)
           on-success (fn [_] #_(println "DELETE:" show-popup) (on-success show-popup))]
       [:f> are-you-sure-popup-form* msg on-success on-close])]))

(defn are-you-sure-word-popup [msg-fn on-success & [on-close]]
  (when-let [show-popup @(rf/subscribe [::db/get ::show-are-you-sure-popup])]
    [:> Modal {:aria-labelledby  "simple-modal-title"
               :aria-describedby "simple-modal-description"
               :style            {:display        "flex"
                                  :marginRight    "auto"
                                  :marginLeft     "auto"
                                  :alignItems     "center"
                                  :justifyContent "center"}
               :open             (if (nil? show-popup) false true)

               }
     ;[:pre (pr-str show-popup)]
     (let [msg (msg-fn show-popup)
           on-success (fn [_] #_(println "DELETE:" show-popup) (on-success show-popup))
           !control (r/atom "")]
       [:f> are-you-sure-word-popup-form* !control msg on-success on-close])]))